module.exports = __webpack_public_path__ + "static/media/green-tick-hollow.0a93d282.svg";